<template>
    <div class="comContent page-content">
        <div class="expand-form">
            <div style="width: 100%; " class="flex-box al-center">
                <div>
                    {{ details.name }}
                </div>

                <div>
                    <el-button v-if="[0, 1, 3].includes(details.status)" size="small" type="primary" @click="create({}, 'create')" key="create">新建</el-button>
                    <el-button size="small" type="plain" @click="goBack()">返回</el-button>
                </div>
            </div>
        </div>
        <div class="activity-goods-list">
            <div class="expand-form" style="margin-top:10px;">
                <searchForm v-model="searchData" :formItems="searchLabelList" @search="onSearch" @reset="resetForm">
                    <div slot="right">
                        <el-button v-if="isEdit" size="small" type="plain" @click="onBatchRemoval">批量移除</el-button>
                    </div>
                </searchForm>
            </div>
            <myTable selection :page="page" v-loading="loading" :table-data="tableData" :table-option.sync="tableOption"
                @page-change="getList" @handleSelectionChange="handleSelectionChange">
                <template slot="goodsRange" slot-scope="scope">
                    {{ scope.row.goodsRange | filtersGoodsRange }}
                </template>
                <template slot="platformActivityGoodsInfoVO" slot-scope="scope">
                    <div class="goods-info" v-if="scope.row.platformActivityGoodsInfoVO">
                        <div class="goods-info-image">
                            <el-image :src="scope.row.platformActivityGoodsInfoVO.image || avater" lazy
                                style="width:100%;height: 100%;" />
                        </div>
                        <div class="goods-info-content">
                            <p class="goods-name">
                                {{ scope.row.platformActivityGoodsInfoVO.goodsName }}
                            </p>
                            <p>
                                规格: {{ scope.row.platformActivityGoodsInfoVO.specification || '-' }}
                            </p>
                            <p>
                                生产厂家: {{ scope.row.platformActivityGoodsInfoVO.factory || '-' }}
                            </p>
                            <p>
                                69码: {{ scope.row.platformActivityGoodsInfoVO.barCode || '-' }}
                            </p>
                        </div>
                    </div>
                </template>
                <template slot="productScopeType" slot-scope="scope">
                    {{ scope.row.productScopeType | filtersStatus }}
                </template>
                <template slot="subsidyType" slot-scope="scope">
                    <div class="subsidy-type-cls">
                        <div>
                            <span>一次性买满{{ scope.row.threshold }}元</span>
                        </div>
                        <div v-if="scope.row.type == 1">
                            <span>{{ scope.row.discount }}折<br /></span>
                        </div>

                        <div v-if="scope.row.type == 2">
                            减固定金额 ￥ {{ scope.row.discount }}<br />
                        </div>
                        <span v-if="scope.row.singleGoodsLimitFlag == '0'"> 单笔订单无上限</span>
                        <span v-if="scope.row.singleGoodsLimitFlag == '1'"> 单笔订单上限{{ scope.row.singleGoodsLimit }}元</span>
                    </div>
                </template>
                <template slot="operation" slot-scope="scope" v-if="[0,1,3].includes(details.status)">
                    <div style="margin: 0 0px">
                        <!-- <el-link type="primary" :underline="false" @click="checkDetail(scope.row, 'edit')"
                      style="margin-right: 10px">
                      编辑
                  </el-link> -->
                        <el-link type="primary" :underline="false" @click="subsidyGoodsDelete(scope.row, 'detel')"
                            style="margin-right: 10px">
                            移除
                        </el-link>
                    </div>
                </template>
            </myTable>
        </div>
        <createRules ref="createRules" @refresh="resetForm" />
    </div>
</template>
<script>
import searchForm from "./component/searchForm.vue";
import myTable from "@/components/myTable";
import { subsidyDetails, subsidyGoodsInfo, deleteSubsidyGoodsList, subsidyGoodsDelete } from "@/api/platSubsidyManage";
import createRules from "./component/createRules.vue";
import avater from "/public/img/default.png"
// 平台补贴商品
const ruleTypeOptions = [
    {
        name: "基准库分类",
        id: 0,
    },
    {
        name: "指定店铺",
        id: 1,
    },
    {
        name: "店铺指定商品",
        id: 2,
    },
];
export default {
    components: { searchForm, myTable, createRules },
    props: {},
    data() {
        return {
            details: {
                goodsFrom: 0,
                name: '',
                status: '0' // 0草稿1待开始2已停止 3进行中 4已结束")
            },
            avater,
            id: this.$route.query.id,
            searchLabelList: [
                {
                    name: "商品范围",
                    fieldName: "goodsRange",
                    type: "select",
                    select: ruleTypeOptions,
                },
                {
                    name: "搜索店铺名称",
                    fieldName: "shopName",
                    type: "input",
                    show(e) {
                        // 联动 当商品范围为“指定店铺、店铺指定商品时”，店铺名称下拉框显示
                        const bool = [1, 2].includes(e.goodsRange);
                        if (!bool) {
                            e.shopName = ''
                        }
                        return bool
                    }
                },
                {
                    name: "搜索商品信息",
                    fieldName: "goodsInfo",
                    type: "input",
                },
                {
                    fieldName: "date",
                    type: "daterange",
                    width: 240,
                    $attrs: {
                        placeholder: '更新时间'
                    }
                },

            ],
            searchData: this.searchDataInit(),
            loading: false,
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "商品范围", prop: "goodsRange", slot: true },
                { label: "店铺名称", prop: "shopName", },
                { label: "商品信息", prop: "platformActivityGoodsInfoVO", slot: true, minWidth: 200 },
                { label: "SKU活动库存下限", prop: "skuInventoryMin", },
                { label: "SKU价格上限", prop: "skuPriceMax", type: 'money' },
                // { label: "补贴价", prop: "subsidyPrice", type: 'money' },
                { label: "补贴方式", prop: "subsidyType", slot: true, minWidth: 150 },
                { label: "已补贴金额", prop: "discountMoney", type: 'money' },
                { label: "更新人", prop: "updateBy", },
                { label: "更新时间", prop: "updateTime", },
                { label: "操作", prop: "operation", slot: true },
            ],
            selectionList: []
        };
    },
    filters: {
        filtersStatus(e) {
            for (let i = 0; i < ruleTypeOptions.length; i++) {
                if (e == ruleTypeOptions[i].id) {
                    return ruleTypeOptions[i].name
                }
            }
        },
        // 商品范围：0基准库商品 1指定店铺全部商品 2店铺指定商品
        filtersGoodsRange(e) {
            const obj = ruleTypeOptions.find(i => i.id === e)
            return obj?.name || e
        }
    },
    computed: {
        isEdit() {
            return [0, 1, 3].includes(this.details.status)
        }
    },
    created() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.subsidyDetails();
        }
        this.getList();
    },
    mounted() { },
    methods: {
        subsidyDetails() {
            subsidyDetails(this.id).then((res) => {
                if (res && res.id) {
                    this.details = res;
                }
            });
        },
        // 查看详情
        create(row, type) {
            if (type == 'create') {
                this.$refs['createRules'].init({}, 'create');
            }
        },
        goBack() {
            this.$router.back(-1)
        },
        // 批量移除
        onBatchRemoval() {
            if (!this.selectionList.length) {
                this.$message.warning('请勾选要移除的商品')
                return
            }
            this.$confirm(`确定要移除勾选的商品吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                const ids = this.selectionList.map(({ id }) => id)
                deleteSubsidyGoodsList(ids).then(res => {
                    this.$message.success('操作成功！')
                    this.getList()
                })

            }).catch(() => { });
        },
        handleSelectionChange(val) {
            this.selectionList = val;
        },
        searchDataInit() {
            return {
                shopName: '', // 店铺名称
                goodsInfo: '', // 商品信息
                goodsRange: '', // 商品范围
                date: [] // 活动时间
            }
        },
        onSearch() {
            this.page.current = 1;
            this.getList();
        },
        resetForm() {
            this.page.current = 1;
            this.searchData = this.searchDataInit();
            this.getList();
        },
        getList() {
            const { date, ...form } = this.searchData;
            const { current, size } = this.page;
            const params = {
                ...form,
                current,
                size,
                subsidyId: this.id
            };
            if (date && date.length) {
                params.strTime = date[0];
                params.endTime = date[1];
            }
            this.loading = true
            subsidyGoodsInfo(params).then((res) => {
                this.tableData = res.records || [];
                this.page.total = res.total || 0;
            }).finally(() => {
                this.loading = false
            })
        },
        subsidyGoodsDelete(row) {
            this.$confirm(`确定要移除吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    if (row.id) {
                        // 删除活动商品
                        subsidyGoodsDelete(row.id).then((res) => {
                            this.$message.success('操作成功！')
                            this.getList()
                        }).catch((err) => { })
                    }

                })
                .catch(() => { });

        },
        goBack() {
            this.$router.back(-1)
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
    height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
    height: calc(100% - 97px) !important;

}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 65px) !important;
    overflow-y: scroll !important;
}

.page-content {
    display: flex;
    flex-direction: column;
}

.activity-goods-list {
    // height: 100%;
    flex: 1;
    height: 0;
}

.expand-form {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.flex-box {
    display: flex;
    justify-content: space-between;

    &.al-center {
        align-items: center;
    }
}

.goods-info {
    min-width: 150px;
    display: flex;
    align-items: flex-start;

    &-image {
        width: 80px;
        height: 80px;
        flex-shrink: 0;
    }

    &-content {
        margin-left: 8px;

        p {
            margin: 0;
            font-size: 12px;
        }

        .goods-name {
            font-weight: 600;
        }
    }
}
.subsidy-type-cls{
    font-size: 13px;
}
</style>
  